/* eslint @typescript-eslint/strict-boolean-expressions: off */

import { useRequiredSession } from "src/components/session/session";
import { useEditorParameters, useEditorResult } from "./context";
import { executeQueryAndAddToastOnError } from "shared/executeQuery/executeQueryAndAddToastOnError";

import type { SupportedPublicPerformanceTierKey } from "shared/SelectPerformance/useGetPerformanceTiers";
import type { ActiveContext } from "shared/ContextSwitcher/store";

type UseExecuteQueryOptions = {
  activeContext: ActiveContext | undefined;
  performance: SupportedPublicPerformanceTierKey | undefined;
};

type ExecuteQueryOptions = {
  refresh?: boolean;
  metadata?: Record<string, unknown>;
};

export function useEditorExecuteQuery(options: UseExecuteQueryOptions) {
  const { activeContext, performance } = options;

  const session = useRequiredSession();
  const parameters = useEditorParameters();
  const result = useEditorResult();

  async function executeQuery(queryId: number, options: ExecuteQueryOptions) {
    if (activeContext === undefined || !parameters) {
      return;
    }

    try {
      const { data } = await executeQueryAndAddToastOnError({
        queryId,
        parameters: parameters.merged,
        requestContext: { session },
        activeContext,
        executionType: "interactive",
        performance,
        metadata: options.metadata,
      });

      if (options.refresh) {
        const job = data?.execute_query_v3?.job_id;
        await result?.refresh?.(job, queryId);
        parameters.onApply();
      }

      return true;
    } catch (error) {
      return false;
    }
  }

  return executeQuery;
}
